export const peopleBlocks = state => state.formsV2.peopleBlocks.blocks;
export const peopleBlock = (state, blockId) =>
  state.formsV2.peopleBlocks.byId[blockId] || {};
export const peopleBlockFields = (state, blockId) =>
  peopleBlock(state, blockId).fields || [];
export const peopleBlockItemBlocks = (state, blockId) =>
  peopleBlock(state, blockId).item_blocks || [];
